<template>
<div>
    <v-overlay v-if="guardarRevision" class="text-center">
        <h3>Guardando Revisión...</h3>
        <v-spacer></v-spacer>
        <sync-loader :loading="guardarRevision" color="#2196F3" class="mt-3"></sync-loader>
    </v-overlay>

    <v-data-table :headers="headers" :items="arrayFiltrado" :items-per-page="15" sort-by="fechaCreate" :sort-desc="true" class="elevation-1" :single-expand="singleExpand" :expanded.sync="expanded" item-key="factura" show-expand v-if="existeUsuario" :loading="carga ? true : false" loading-text="Cargando... Espere un momento" :footer-props="footerProps">
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Abonos</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-form @submit.prevent="buscador(search)" class="d-flex flex-row no-wrap" style="width: 100%; max-width: 60%">
                    <v-row>
                        <v-col cols="5">
                            <v-select v-model="search" flat solo-inverted hide-details :items="selectSearch" prepend-inner-icon="mdi-magnify" label="Filtrar" v-on:change="buscador(search)" v-if="usuario.rol == 'ADMIN'"></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="6">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar factura, cliente o nº abono..." single-line hide-details class="mt-2" v-on:keyup="buscador(search)"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>

            </v-toolbar>
            <!-- Alerta de Tramite Auth: Component -->
            <Alert></Alert>

            <v-divider class="mb-4"></v-divider>

        </template>
        <template v-slot:item.codigoAbono="{ item }">
            <code v-if="item.codigoAbono">{{ item.codigoAbono }}</code>
            <span v-else class="grey--text">—</span>
        </template>
        <template v-slot:item.productos="{ item }">
            <span v-html="item.productos"></span>
        </template>
        <template v-slot:item.actions="{ item }">
            <!-- Detalles: Component -->
            <Detalles :abono="item"></Detalles>
            <!-- Autorizacion -->
            <Editar :abono="item" v-if="usuario.rol == 'ADMIN' && usuario != ''"></Editar>
            <!-- Revision -->
            <Revision :abono="item" v-if="puedeRevisar(item)"></Revision>
            <!-- Eliminar Abono-->
            <v-icon small class="mr-2" @click="eliminarAbono(item.id)" v-if="usuario.rol == 'ADMIN'">mdi-delete</v-icon>
            <VueGallerySlideshow :images="images" :index="index" @close="index = null"></VueGallerySlideshow>
            <v-icon small class="mr-2" @click="showGallery(item.images)" v-if="item.images">mdi-image</v-icon>
            <!-- si es abonador-->
            <v-icon small class="mr-2" @click="openRecogerDialog(item)" v-if="(usuario.rol == 'RECOGER' || usuario.email == 'francisco.delgado@av-online.es') && item.tramitar == 'Tramitado' && !item.recogido && !item.abonado">mdi-package-variant</v-icon>
            <!-- si es abonador-->
            <v-icon small class="mr-2"
            @click="openAbonarDialog(item)"
            v-if="usuario.rol == 'ABONAR' && item.tramitar == 'Tramitado' && item.recogido && !item.abonado">
            mdi-currency-eur
            </v-icon>

            <!-- si es admin -->
            <v-chip class="ma-2 text--white" :color="item.color" text-color="white" v-if="item.autorizado == 'En Espera' || item.tramitar == 'En Espera' && item.autorizado == 'Denegado' || usuario.rol == 'ADMIN' && item.autorizado == 'Aceptado' && item.tramitar == 'En Espera'">
                {{item.autorizado}}
            </v-chip>
            <!-- si no es admin -->
            <v-chip class="ma-2 text--white" color="purple" text-color="white" v-if="item.tramitar == 'En Espera' && usuario.rol != 'ADMIN' && item.autorizado != 'Denegado' && item.autorizado != 'En Espera'">
                En Revision
            </v-chip>
            <!-- si se ha tramitado -->
            <v-chip class="ma-2 text--white" color="green" text-color="white" v-if="item.tramitar != 'En Espera' && item.tramitar == 'Tramitado'">
                {{item.tramitar}}
            </v-chip>

            <!-- si no se ha tramitado -->
            <v-chip class="ma-2 text--white" color="red" text-color="white" v-if="item.tramitar != 'En Espera' && item.tramitar == 'No tramitado'">
                {{item.tramitar}}
            </v-chip>
            <!-- si se ha recogido -->
            <v-avatar class="ma-1" color="deep-orange" v-if="item.recogido == true" size="28">
                <v-icon dark>mdi-package-variant-closed</v-icon>
            </v-avatar>
            <!-- si almacén lo rechaza -->
            <v-chip class="ma-2" color="red" text-color="white" small v-if="item.rechazoAlmacen == true">
                Rechazado almacén
            </v-chip>
            <!-- si se ha abonado-->
            <v-avatar class="ma-1" color="indigo" v-if="item.abonado == true" size="28">
                <v-icon dark>mdi-currency-eur</v-icon>
            </v-avatar>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">Motivo: {{ item.motivo }}</td>
        </template>

    </v-data-table>
    <!-- Diálogo recepción almacén: recibido o rechazado -->
    <v-dialog v-model="dlgRecoger" max-width="520px" persistent>
        <v-card>
            <v-card-title class="headline">Recepción en almacén</v-card-title>
            <v-card-text>
                <p class="mb-2">Factura {{ itemRecoger && itemRecoger.factura }}</p>
                <v-form ref="formRecoger" v-model="formOkRecoger">
                    <v-radio-group v-model="decisionRecoger" row :rules="[v => !!v || 'Elige una opción']">
                        <v-radio label="Lo tengo" value="recibido"></v-radio>
                        <v-radio label="Rechazar" value="rechazado"></v-radio>
                    </v-radio-group>
                    <v-textarea
                        v-model="observRecoger"
                        :label="decisionRecoger === 'rechazado' ? 'Motivo del rechazo' : 'Observaciones (opcional)'"
                        :rules="observRecogerRules"
                        :hint="decisionRecoger === 'rechazado' ? 'Obligatorio. Indica por qué no se puede recoger.' : 'Puedes anotar incidencias aunque lo des por recibido.'"
                        persistent-hint
                        rows="3"
                        auto-grow
                    ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="cancelRecoger">Cancelar</v-btn>
                <v-btn color="primary" @click="confirmRecoger">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Diálogo Nº de abono Pyme (persistente) -->
    <v-dialog v-model="dlgAbonar" max-width="480px" persistent>
    <v-card>
        <v-card-title class="headline">Confirmar abono</v-card-title>
        <v-card-text>
        <v-form ref="formAbonar" v-model="formOkAbonar">
            <v-text-field
            v-model="numeroAbonoPyme"
            label="Nº de abono Pyme"
            :rules="numeroAbonoRules"
            required
            autofocus
            clearable
            />
            <small>Obligatorio para confirmar el abono.</small>
        </v-form>
        </v-card-text>
        <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancelAbonar">Cancelar</v-btn>
        <v-btn color="primary" :disabled="!formOkAbonar" @click="confirmAbonar">
            Confirmar abono
        </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
} from 'vuex';
import Detalles from '../components/Detalles';
import Revision from '../components/Revision';
import Editar from '../components/Editar';
import Alert from '../components/Alert';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import emailjs from 'emailjs-com';
import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
    components: {
        Detalles,
        Revision,
        Editar,
        SyncLoader,
        Alert,
        VueGallerySlideshow
    },
    data: () => ({
        dialog: false,
        autorizar: false,
        index: null,
        images: [],
        headers: [{
                text: 'Nº Abono',
                align: 'start',
                value: 'codigoAbono',
                width: '9%'
            },
            {
                text: 'Factura',
                align: 'start',
                filterable: false,
                value: 'factura',
            },
            {
                text: 'Fecha',
                value: 'fecha',
                width: '10%'
            },
            {
                text: 'Cliente',
                value: 'cliente'
            },
            {
                text: 'Productos',
                value: 'productos'
            },
            {
                text: 'Comercial',
                value: 'comercial'
            },
            {
                text: 'Acciones',
                value: 'actions',
                width: '15%'
            },
        ],
        footerProps: {
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
            'items-per-page-options': [10, 20, 30, 40, 50],
            'items-per-page-text': 'Columnas por página:'
        },
        editedIndex: -1,
        expanded: [],
        singleExpand: false,
        condiciones: '',
        search: '',
        selectSearch: [
            'Aceptado',
            'Denegado',
            'En Espera'
        ],
        dlgRecoger: false,
        itemRecoger: null,
        decisionRecoger: 'recibido',
        observRecoger: '',
        formOkRecoger: false,
        dlgAbonar: false,
        itemAbonar: null,
        numeroAbonoPyme: '',
        formOkAbonar: false,
        numeroAbonoRules: [
            v => !!v || 'Obligatorio',
            v => String(v).trim().length >= 4 || 'Mínimo 4 caracteres',
            v => /^[A-Za-z0-9\-\/]+$/.test(v) || 'Solo letras, números y - /'
        ],
    }),
    computed: {
        emailUsuario() {
            return String((this.usuario && this.usuario.email) || '').toLowerCase()
        },
        observRecogerRules() {
            if (this.decisionRecoger !== 'rechazado') return []
            return [
                v => !!String(v || '').trim() || 'Indica el motivo',
                v => String(v || '').trim().length >= 3 || 'Mínimo 3 caracteres'
            ]
        },
        formTitle() {
            return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
        },
        /* Custom */
        ...mapState(['usuario', 'abonos', 'showDetalles', 'carga', 'guardarRevision']),
        ...mapMutations(['setShowDetalles', 'setAbono']),
        ...mapGetters(['existeUsuario', 'getUsuarioActual', 'arrayFiltrado'])
    },

    watch: {
        dialog(val) {
            val || this.close()
        },
    },
    mounted() {
        const token = localStorage.getItem('access_token');
        this.getAbonos(token)
    },

    methods: {
        /* Custom */
        ...mapActions(['getAbonos', 'eliminarAbono', 'buscador', 'Abonar', 'RecogerAbono']),
        ...mapMutations(['mostrarDetalles']),
        detallesAbono(abono) {
            this.setAbono(abono);
            this.setShowDetalles(true);
        },
        puedeRevisar(item) {
            if (!item || item.tramitar != 'En Espera' || item.autorizado != 'Aceptado') return false
            if (this.usuario && this.usuario.rol == 'REVISAR') return true
            return this.emailUsuario == 'francisco.delgado@av-online.es'
                || this.emailUsuario == 'victor.hernandez@av-online.es'
        },
        showGallery(images) {
            this.images = images
            this.index = 0
        },
        openRecogerDialog(item) {
            this.itemRecoger = item
            this.decisionRecoger = item.rechazoAlmacen ? 'rechazado' : 'recibido'
            this.observRecoger = item.observAlmacen || ''
            this.dlgRecoger = true
            this.$nextTick(() => this.$refs.formRecoger && this.$refs.formRecoger.resetValidation())
        },
        cancelRecoger() {
            this.dlgRecoger = false
            this.itemRecoger = null
            this.decisionRecoger = 'recibido'
            this.observRecoger = ''
        },
        async confirmRecoger() {
            const ok = await this.$refs.formRecoger.validate()
            if (!ok || !this.itemRecoger) return
            await this.RecogerAbono({
                abono: this.itemRecoger,
                decision: this.decisionRecoger,
                observacion: this.observRecoger
            })
            this.dlgRecoger = false
            this.itemRecoger = null
            this.decisionRecoger = 'recibido'
            this.observRecoger = ''
        },
        abonarProductos(abono) {
            this.Abonar(abono);
        },
        openAbonarDialog(item) {
            this.itemAbonar = item
            this.numeroAbonoPyme = item.numeroAbonoPyme || ''
            this.dlgAbonar = true
            this.$nextTick(() => this.$refs.formAbonar && this.$refs.formAbonar.resetValidation())
        },
        cancelAbonar() {
            this.dlgAbonar = false
            this.itemAbonar = null
            this.numeroAbonoPyme = ''
        },
        async confirmAbonar() {
            const ok = await this.$refs.formAbonar.validate()
            if (!ok) return
            // pasa el número al store
            await this.Abonar({
            id: this.itemAbonar.id,
            numeroAbonoPyme: this.numeroAbonoPyme
            })
            this.dlgAbonar = false
            this.itemAbonar = null
            this.numeroAbonoPyme = ''
        },

    },
}
</script>
